export default {"src":"https://appsumo2next-cdn.appsumo.com/_next/static/media/award-badge.8c6d4589.svg","height":24,"width":22};